import axios from "axios";

const PATH = "/timecontrolling";

export default {
  getTimesWithoutTeamlead () {
    return axios.get(`${PATH}/without-teamlead`);
  }
};
